import { Profiler, Color } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Profiler {
        setColor(color: Color): void;
        setColor(colorHex: string): void;
    }
}

if (Profiler) {
    Profiler.prototype.setColor = function setColor(color: Color | string): void {
        this.showStats();
        if (typeof color === 'string') {
            (this._ctx as CanvasRenderingContext2D).fillStyle = color;
        } else if (color instanceof Color) {
            (this._ctx as CanvasRenderingContext2D).fillStyle = `#${color.toHEX()}`;
        }
        /** this._statsDone 設為 false，使 generateStats 函數的條件進得去，讓 profiler 面板的 ctx 在重新生成一次 */
        this._statsDone = false;
        this.generateStats();
    };
}
